<footer class="fixed-bottom">
  <div class="bg-primary py-3">
      <div class="d-flex">
          <img src="../../../assets/svg/INNBIT-Powered-White.svg" class="m-auto INN-poweredBy" alt="">
      </div>
  </div>
</footer>